module.exports = __webpack_public_path__ + "img/banner-new-store-list-onnuri-kor.82c55649.png";